import Button, { ButtonProps } from "../../../common/forms/button";
import React, { PropsWithChildren } from "react";
import { PageHeader } from "./PageHeader";

export type DealPageActionButtonInfo = {
  label: string;
  primary?: boolean;
  dataTestId: string;
  disabled?: boolean;
  onClick: () => void;
};

type DealsPageHeaderProps = PropsWithChildren<{
  title?: string;
  subTitle?: string;
  leftAction?: React.ReactNode;
  rightAction?: React.ReactNode;
  actionButtons?: DealPageActionButtonInfo[];
  showDelimiter?: boolean;
  isSidebar?: boolean;
  onHeightChange?: (height: number) => void;
}>;

export const DealsPageHeader = (props: DealsPageHeaderProps) => {
  const {
    title,
    subTitle,
    leftAction,
    rightAction,
    actionButtons,
    showDelimiter = true,
    isSidebar = false,
    onHeightChange,
  } = props;

  return (
    <PageHeader
      title={title}
      subTitle={subTitle}
      showDelimiter={showDelimiter}
      leftAction={leftAction}
      isSidebar={isSidebar}
      onHeightChange={onHeightChange}
    >
      {rightAction && rightAction}
      {actionButtons &&
        actionButtons.map((buttonInfo, index) => {
          let buttonType: ButtonProps["type"] = "primary";

          if (buttonInfo.primary && buttonInfo.disabled) {
            buttonType = "disabled-primary";
          } else if (!buttonInfo.primary && buttonInfo.disabled) {
            buttonType = "disabled-secondary";
          } else if (!buttonInfo.primary) {
            buttonType = "secondary";
          }

          return (
            <Button
              key={index}
              disabled={buttonInfo.disabled}
              data-testid={buttonInfo.dataTestId}
              type={buttonType}
              size="medium"
              onClick={buttonInfo.onClick}
            >
              {buttonInfo.label}
            </Button>
          );
        })}
    </PageHeader>
  );
};
